
















































/* tslint:disable:no-console */
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Route } from "vue-router";
import { ISortParameters, ITransaction } from "@/interfaces";
import NotFound from "@/components/utils/NotFound.vue";
import TransactionDetails from "@/components/transaction/Details.vue";
import MultiPaymentTransactions from "@/components/tables/MultiPaymentTransactions.vue";
import TransactionService from "@/services/transaction";
import { paginationLimit } from "@/constants";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    NotFound,
    TransactionDetails,
  },
  computed: {
    ...mapGetters("network", ["height"]),
    ...mapGetters("network", { networkSymbol: "symbol" }),
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class TransactionPage extends Vue {
  private transaction: ITransaction | null = null;
  private transactionNotFound = false;
  private isLoading = false;
  private meta: any | null = null;
  private currentPage = 1;
  private height: number;
  private networkSymbol: string;
  private smartbridgeFilter: string;

  get showPagination() {
    return this.meta && this.meta.pageCount > 1;
  }

  @Watch("smartbridgeFilter")
  public onSmartbridgeFilterChanged() {
    if (this.smartbridgeFilter !== "hidden") {
      this.fetchTransaction();
    }
  }

  public async beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
    try {
      const transaction = await TransactionService.find(to.params.id);
      next((vm: TransactionPage) => {
        vm.setTransaction(transaction);
        vm.calculateMeta();
      });
    } catch (e) {
      next((vm: TransactionPage) => {
        console.log(e.message || e.data.error);

        vm.transactionNotFound = true;
        // @ts-ignore
        vm.transaction = { id: to.params.id };
      });
    }
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.transaction = null;

    try {
      const transaction = await TransactionService.find(to.params.id);
      this.setTransaction(transaction);
      this.calculateMeta();
      next();
    } catch (e) {
      console.log(e.message || e.data.error);

      this.transactionNotFound = true;
      // @ts-ignore
      this.transaction = { id: to.params.id };
    }
  }

  private async fetchTransaction() {
    this.isLoading = true;

    try {
      const transaction = await TransactionService.find(this.transaction!.id);
      this.setTransaction(transaction);
      this.transactionNotFound = false;
    } catch (e) {
      console.log(e.message || e.data.error);
    } finally {
      setTimeout(() => (this.isLoading = false), 750);
    }
  }

  private setTransaction(transaction: ITransaction) {
    this.transaction = transaction;
  }

  private onPageChange(page: number) {
    if (this.currentPage !== page) {
      this.currentPage = page;
      this.meta.count = page;
      this.meta.self = page.toString();
      this.meta.next = page < this.meta.pageCount ? (page + 1).toString() : null;
      this.meta.previous = page > 1 ? (page - 1).toString() : null;

      // @ts-ignore
      this.$refs.transactionDetails.$el.scrollIntoView(false);
    }
  }

  private calculateMeta() {
    // @ts-ignore
    if (this.transaction && this.isMultiPayment(this.transaction.type, this.transaction.typeGroup)) {
      const transactions = this.transaction.asset.payments.length;
      const pages = Math.ceil(transactions / paginationLimit);
      this.meta = {
        count: transactions >= paginationLimit ? paginationLimit : transactions,
        pageCount: pages,
        totalCount: transactions,
        next: pages > 1 ? "2" : null,
        previous: null,
        self: "1",
        first: "1",
        last: pages.toString(),
      };
    }
  }

  private onReload() {
    this.fetchTransaction();
  }
}
